export const LOGIN = {
  name: 'login',
  path: '/login',
};

export const LOGOUT = {
  name: 'logout',
  path: '/logout',
};

export const REGISTER = {
  name: 'register',
  path: '/register',
};

export const VERIFY_EMAIL = {
  name: 'verify-email',
  path: '/verify-email',
};

export const FORGOT_PASSWORD = {
  name: 'forgot-password',
  path: '/password/forgot',
};

export const RESET_PASSWORD = {
  name: 'reset-password',
  path: '/password/reset',
};

export const RESET_PASSWORD_LEGACY = {
  name: 'reset-password-legacy',
  path: '/password-reset',
};

export const SET_PASSWORD = {
  name: 'set-password',
  path: '/password/set',
};

export const SET_PASSWORD_LEGACY = {
  name: 'set-password',
  path: '/password-set',
};

export const SSO_SIGN_IN = {
  name: 'ssoSignIn',
  path: '/login/sso',
};

export const LMS_SSO = {
  name: 'lmsSso',
  path: '/lms-login',
};
